import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const formatDate = (date) =>
    date?.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) ?? 'mm/dd/yyyy';

const OIDatePicker = ({
    externalDate,
    onInternalChange,
    name,
    isdisabled,
    loading,
    ISBNId,
    flag,
}) => {
    const [offset, setOffset] = useState(0);
    const [calanderDate, setCalanderDate] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [showPicker, setShowPicker] = useState(false);
    const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                if (showPicker) {
                    handleInputBlur();
                }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showPicker, inputValue]);
  /*  const parseDateSafe = (value) => {
      
        if (!value || typeof value !== "string") return null;

        // Match YYYY-MM-DD or YYYY/MM/DD
        const dateOnlyMatch = value.match(/^(\d{4})[-/](\d{2})[-/](\d{2})/);
        if (dateOnlyMatch) {
            const [, y, m, d] = dateOnlyMatch;
            return new Date(Number(y), Number(m) - 1, Number(d)); // always local midnight
        }

        // Fallback: try native Date but strip time
        const fallback = new Date(value);
       
        if (!isNaN(fallback)) {
            return new Date(fallback.getFullYear(), fallback.getMonth(), fallback.getDate());
        }

        return null;
    };*/

    const parseDateSafe = (value) => {
        if (!value) return null;

       

        if (typeof value === "string") {
            // Match YYYY-MM-DD or YYYY/MM/DD
            const dateOnlyMatch = value.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
            if (dateOnlyMatch) {
                const [, y, m, d] = dateOnlyMatch;
                return new Date(Number(y), Number(m) - 1, Number(d));
            }

            // Try native Date
            const fallback = new Date(value);
            if (!isNaN(fallback)) {
                return new Date(fallback.getFullYear(), fallback.getMonth(), fallback.getDate());
            }
        }
        // Already a Date
        if (value instanceof Date && !isNaN(value)) {
            return new Date(value.getFullYear(), value.getMonth(), value.getDate());
        }
        return null;
    };


    const setDefaultDate = () => {
        if (externalDate === null || externalDate === "") {
            setInputValue("");
            setCalanderDate(null);
        } else if (externalDate) {
            const parsed = parseDateSafe(externalDate);

            if (!isNaN(parsed)) {
                setCalanderDate(parsed);
                setInputValue(formatDate(parsed));
            } else {
                setInputValue("");
                setCalanderDate(null);
            }
        }
    }

    useEffect(() => {
        setDefaultDate();
    }, [externalDate]);

    useEffect(() => {
        setOffset(0);
        setShowPicker(false);
    }, [ISBNId])
    const parseDate = (val) => {
        const parts = val.replace(/-/g, "/").split("/");
        if (parts.length === 3) {
            const [month, day, year] = parts.map(Number);
            if (month >= 1 && month <= 12 && day >= 1 && day <= 31 && !isNaN(year)) {
                return new Date(year, month - 1, day, 0, 0, 0);
            }
        }
        return null;
    };

   /* const toDateOnlyString = (date) =>
        `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
*/

    const handleOffsetChange = (e) => {
        if (e.target.value === "") {
            setOffset("");
            setDefaultDate();
            return;
        }
        const newOffset = parseInt(e.target.value);
        if (newOffset < 0) return;
        setOffset(newOffset);
        const newDate = new Date();
        newDate.setDate(newDate.getDate() + 7 * newOffset);
        setCalanderDate(newDate);
        setInputValue(formatDate(newDate));
    };

    useEffect(() => {
        if (flag) {
            setOffset(0);
            setInputValue("");
            setCalanderDate(null);
        }
    }, [flag]);

    const handleInputBlur = () => {
        let parseddate;
        try {
            parseddate = parseDate(inputValue);
            if (
                (parseddate && !isNaN(parseddate))
                &&
                ((externalDate && !isNaN(new Date(externalDate)) &&
                    parseddate.getTime() != new Date(externalDate).getTime()) || (!externalDate ||
                        isNaN(new Date(externalDate)) ))
            ) {
    
                if (parseddate && !isNaN(parseddate)) {
                    setCalanderDate(parseddate);
                    onInternalChange?.({ target: { name, value: parseddate } });
                } else {
                    setInputValue("");
                    setCalanderDate(null);
                    if (inputValue == null || inputValue?.trim() == "") {
                        onInternalChange?.({ target: { name, value: null } });
                    }
                }
            } else {
               
                return;
            }
        } catch (error) {
            console.error("invalid date format:", error);
            setInputValue("");
            setCalanderDate(null);
        } finally {
            setShowPicker(false);
        }
    };

    useEffect(() => {
        if (!showPicker || !wrapperRef.current) return;
        const updatePosition = () => {
                const rect = wrapperRef.current.getBoundingClientRect();
                setPickerPosition({
                    top: rect.bottom,
                    left: rect.left
                });
        };
        if (!showPicker) return;
        window.addEventListener("scroll", updatePosition, { passive: true });
        window.addEventListener("resize", updatePosition);
        updatePosition();
        return () => {
            window.removeEventListener("scroll", updatePosition, { passive: true });
            window.removeEventListener("resize", updatePosition);
        };
    }, [showPicker]);

  /*  const debounceInternalChange = (data) => {
        clearTimeout(internalChangeTimeoutRef.current);
        internalChangeTimeoutRef.current = setTimeout(() => {
            onInternalChange?.({ target: { name, value: data } });
        }, 1000);
    };*/

    return (
        <div
            className="relative inline-block text-left rounded-xl shadow-md"
            ref={wrapperRef}
            onBlur={() => { if (!showPicker) handleInputBlur(); }}
        >
            <input
                disabled={isdisabled || loading}
                type="text"
                style={{
                    border: "1px solid black",
                    borderRadius: "3px",
                    fontSize: "11px",
                    display: "flex",
                    paddingLeft: "6px"
                }}
                placeholder="mm/dd/yyyy"
                className="dateInput bg-gray-100 cursor-text"
                value={inputValue}
                 onChange={(e) => {
                    const val = e.target.value;

                    // Check: not null/empty, only digits and slashes, and no more than 2 slashes
                    const isValidChars = /^[0-9/]*$/.test(val);
                    const slashCount = (val.match(/\//g) || []).length;

                    if (!isValidChars || slashCount > 2 || val.length > 10) {
                        return;
                    } else {
                        setInputValue(val);
                        let parseddate = parseDate(val);

                        if (parseddate && !isNaN(parseddate)) {
                            setCalanderDate(parseddate);
                        }
                    }
                   // setShowPicker(false);
                 }
                }

                onKeyDown={(e) => {
                    if (e.key === "Enter") handleInputBlur();
                }}

                onClick={() => setShowPicker(prev=>!prev)}
                onBlur={() => {
                    if (!showPicker) {
                        handleInputBlur();
                    }
                }}
            />
           
          
            {showPicker && (
                <div
                    className="flex flex-col z-50 rounded bg-white shadow-md"
                    style={{
                        position: "fixed",
                        top: pickerPosition.top ,
                        left: pickerPosition.left,
                        zIndex: 1,
                        border: "1px solid grey",
                    }}
                   // onBlur={handleInputBlur}
                >
                    <div className="flex items-center p-2">
                        <input
                            style={{ width: "50px", height: "20px", fontSize: "14px", borderBottom: "none" }}
                            type="number"
                            className="border p-2 rounded mr-2"
                            value={offset}
                            min={0}
                            onChange={handleOffsetChange}
                            placeholder="Offset"
                            disabled={isdisabled || loading}
                        />
                        <span>Weeks</span>
                    </div>
                    <DatePicker
                        selected={calanderDate}
                        onChange={(date) => {
                            setInputValue(formatDate(date));
                            setCalanderDate(date);
                        }}
                        calendarClassName="custom-datepicker"
                        inline
                        disabled={isdisabled || loading}
                    />
                </div>
            )}
        </div>
    );
};

export default OIDatePicker;